import React from 'react';
import { getAuth, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './PendingApproval.css';

const UserPendingApproval = () => {
  const auth = getAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div className="pending-approval-container">
      <div className="pending-approval-card">
        <div className="icon">⏳</div>
        <h1>Account Pending Approval</h1>
        <p>Thank you for registering as a <strong>User</strong>!</p>
        
        <div className="status-info">
          <h3>What happens next?</h3>
          <ul>
            <li>📧 Our admins have been notified of your registration</li>
            <li>🔍 Your application is currently under review</li>
            <li>✅ You'll receive an email once your account is approved</li>
          </ul>
        </div>

        <div className="contact-info">
          <p><strong>Need help?</strong></p>
          <p>Contact us at: <a href="mailto:info@nezo-app.com">info@nezo-app.com</a></p>
        </div>

        <button onClick={handleSignOut} className="sign-out-btn">
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default UserPendingApproval;
